import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { ViewCart } from "./ViewCart";
import {
  MdOutlineHome,
  MdWorkOutline,
  MdOtherHouses,
  MdOutlineAddCircleOutline,
} from "react-icons/md";
import { HiOutlineArrowLeft, HiOutlineLocationMarker } from "react-icons/hi";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { MdErrorOutline } from "react-icons/md";
import axiosConfig from "../../Service/axiosConfig";
import { useSelector, useDispatch } from "react-redux";
import {
  selectCartTotal,
  selectCartProducts,
  fetchProducts,
} from "../../redux/Slices/cartSlice";
import { PopupModal } from "../PopupModal";
import {
  getDistanceInKm,
} from "../../Utils/geolocation";
import AddressModal from "../../../src-site-exit/components/Cart/AddressModal";
import { getAddresses } from "../../../src-site-exit/utils/accountApi";

// Default delivery radius in km. The backend's /stores/get_store/ endpoint is
// the source of truth, but when we have to fall back to scanning the full
// store list (e.g. backend returns store_id=null) we use this radius for the
// haversine sanity check.
const DELIVERY_RADIUS_KM = 4;

const ViewCartModal = (props) => {
  let dispatch = useDispatch();
  const total = useSelector(selectCartTotal);
  const products = useSelector(selectCartProducts);
  const { cart } = useSelector((state) => state);
  // console.log(cart.products)
  // const [Error, setError] = useState("");
  const [errorMsg, setError] = useState("");
  const [error, seterror] = useState(false);
  const [popupType, setPopupType] = useState("");
  const [message, setMessage] = useState("");
  const [pincode, setPincode] = useState("");
  const [DefaultPincode, setDefaultPincode] = useState("");
  const [miniPopUp, setMiniPopUp] = useState(false);
  const [apiDeliveryCharge, setApiDeliveryCharge] = useState(0);

  // Tracks whether the chosen delivery address (or current location) is
  // within the store's serviceable radius. Driven by /stores/get_store/
  // which returns store_id=null when the location is outside the 4 km
  // delivery zone configured on the backend.
  const [serviceability, setServiceability] = useState({
    status: "idle", // "idle" | "checking" | "serviceable" | "not_serviceable" | "store_offline" | "error"
    message: "",
  });

  const [showAddressModal, setShowAddressModal] = useState(false);

  const [productAmount, setProductAmount] = useState({
    mrp: 0,
    discount: 0,
    delviryCharges: 0,
    PackingCharges: 0,
    totalAmount: 0,
    proamount: 0,
    delivery_waived: null,
    packing_waived: null,
  });

  const {
    count,
    setCount,
    show,
    setShow,
    handleClose,
    orderAddress,
    setOrderAddress,
    setOrders,
    Order,
    ProductData,
    setTotalAmount,
    ChangeAddress,
    GetTheAddress,
    PayMentNavigate,
    handleLoginShow,
    Totalamount,
    MovetoCart,
    isMobile,
    HandleAddress,
    storeNull,
    Address,
    GetAddress,
    travelTime,
    errorMessage,
    setErrorMessage,
  } = props;
  const proceedTotal = productAmount.totalAmount;
  const ProductMRP = async (data) => {
    if (!data || !Array.isArray(data)) {
      return;
    }
    const currentStoreId = localStorage.getItem("storeId");
    if (!currentStoreId) {
      // Avoid hitting delivery charge API with a null store; this was causing
      // backend 500s and noisy logs before a location/store is selected.
      return;
    }

    const rentTotal = (cart?.rentCart || []).reduce((acc, r) => acc + (Number(r.price || 0) * Number(r.qty || 1)), 0);
    const rentOfferTotal = (cart?.rentCart || []).reduce((acc, r) => acc + (Number(r.offerPrice || 0) * Number(r.qty || 1)), 0);

    const totalPrice = data.reduce((acc, product) => {
      const price = parseFloat(product.price);
      const quantity = parseInt(product.quantity);
      return acc + price * quantity;
    }, 0) + rentTotal;

    const offerPrice = data.reduce((acc, product) => {
      const oprice = parseFloat(
        product.offer_price > 0 ? product.offer_price : product.price
      );
      const quantity = parseInt(product.quantity);
      return acc + oprice * quantity;
    }, 0) + rentOfferTotal;

    let delivery_charges = 0;
    let packing_charges = 0;
    let spike_comment = null;
    let totalwt = {
      stores: JSON.parse(currentStoreId),
      products: [],
    };
    let delivery_waived = null;
    let packing_waived = null;
    let spike_percentage = null;
    let free_delivery_charges;

    if (
      JSON.parse(localStorage.getItem("site_data")).ecommerce_type ===
      "Conventional"
    ) {
      totalwt.area = orderAddress?.landmark;
      totalwt.pincode = orderAddress?.pincode;
    }

    data.forEach((item) => {
      totalwt.products.push({
        id: item.id,
        min_qty: item.quantity,
      });
      ProductData.push({
        id: item.id,
        min_qty: item.quantity,
      });
    });

    (cart?.rentCart || []).forEach((item) => {
      totalwt.products.push({
        id: item.id,
        min_qty: item.qty,
      });
      ProductData.push({
        id: item.id,
        min_qty: item.qty,
      });
    });

    // setTotalAmount({
    //   Total_amount: cart.total + delivery_charges + packing_charges,
    // });
    console.log("apiDeliveryCharge:", apiDeliveryCharge);
    console.log("DeliveryCharge:", delivery_charges);
    setOrders({
      ...Order,
      packing_charges,
      delivery_charges,
      spike_comment,
      spike_percentage,
      stores: localStorage.getItem("storeId"),
      user_id: parseFloat(localStorage.getItem("userId")),
      address:
        JSON.parse(localStorage.getItem("site_data")).ecommerce_type ===
          "Conventional" && orderAddress
          ? orderAddress.id
          : localStorage.getItem("address_id"),
      delivery_type:
        JSON.parse(localStorage.getItem("site_data")).ecommerce_type ===
          "Conventional"
          ? ""
          : "Express",
      products: ProductData,
      free_delivery_charges,
    });

    setProductAmount &&
      setProductAmount({
        mrp: totalPrice,
        discount: totalPrice - offerPrice,
        deliveryCharges: delivery_charges,
        PackingCharges: packing_charges,
        // totalAmount: cart.total + delivery_charges + packing_charges,
        totalAmount:
          offerPrice,
        proamount: totalPrice,
        delivery_waived,
        packing_waived,
      });
  };

  useEffect(() => {
    if (errorMessage) {
      const msg = errorMessage.split("-").slice(1).join("-");

      setPopupType("");      // reset popup
      setError(msg);
      setMessage(msg);

      setTimeout(() => {
        setPopupType("error");   // reopen popup
      }, 10);
    }
  }, [errorMessage]);

  const localityFilter = async () => {
    if (pincode.length === 5) {
      try {
        const res = await axiosConfig.get(
          `/masters/check-zipcode-availability/?sale_zipcode=${pincode}`
        );
        if (res.data?.sale_zipcode?.status === "Available") {
          localStorage.setItem("pincode", pincode);
          setDefaultPincode(pincode);
          setPincode("");
          setError(false);
        } else {
          setError(true);
          setDefaultPincode("");
          setPincode("");
        }
      } catch (error) {
        console.error(error);
        setError(true);
        setDefaultPincode("");
        setPincode("");
      }
    } else {
      console.log("disbled");
      setDefaultPincode("");
      setPincode("");
    }
  };

  // useEffect(() => {
  //   ProductMRP(cart.products);
  //   const pincode = localStorage.getItem("pincode");
  //   if (pincode) {
  //     setDefaultPincode(pincode);
  //   }
  // }, [
  //   cart.products,
  //   localStorage.getItem("latitude"),
  //   orderAddress,
  //   localStorage.getItem("longitude"),
  // ]);
  useEffect(() => {
    ProductMRP(cart.products);
    const pincode = localStorage.getItem("pincode");
    if (pincode) {
      setDefaultPincode(pincode);
    }
  }, [
    cart.products,
    cart.rentCart,
    orderAddress,
    apiDeliveryCharge
  ]);
  useEffect(() => {
    if (Address && Address.length > 0) {
      // FIRST PRIORITY → if localStorage has address_id use that
      const savedId = localStorage.getItem("address_id");

      if (savedId) {
        const selected = Address.find(
          (item) => item.id === parseInt(savedId)
        );

        if (selected) {
          setOrderAddress(selected);
          return;
        }
      }

      // SECOND PRIORITY → if no selected address yet
      if (!orderAddress) {
        setOrderAddress(Address[0]);
      }
    }
  }, [Address]);

  // After the backend (or fallback scan) finds a store that can serve the
  // current address, persist it as the active store so /accounts/orders/
  // and the bill-charges call use the correct store rather than whatever
  // store was picked on the homepage.
  const adoptStore = (store) => {
    const storeId = store.id || store.store_id;
    if (!storeId) return;
    const previousStoreId = localStorage.getItem("storeId");
    if (String(previousStoreId) === String(storeId)) return;
    localStorage.setItem("storeId", storeId);
    if (store.opens_at) localStorage.setItem("opens_at", store.opens_at);
    if (store.closes_at) localStorage.setItem("closes_at", store.closes_at);
    if (store.slot_duration) localStorage.setItem("slot_duration", store.slot_duration);
    if (store.address) localStorage.setItem("address", store.address);
    if (store.latitude) localStorage.setItem("store_latitude", store.latitude);
    if (store.longitude) localStorage.setItem("store_longitude", store.longitude);
    // Push the new store id into the in-progress order so the very next
    // bill calculation / payment navigation hits the right store.
    if (setOrders) {
      setOrders((prev) => ({ ...(prev || {}), stores: storeId }));
    }
  };

  // Defensive fallback: if /stores/get_store/ returns no match (or errors)
  // we list every store and run a haversine check ourselves to see if any
  // of them is actually within the delivery radius for the cart address.
  const findServiceableStoreFallback = async (lat, lng, preferOnline = false) => {
    try {
      const response = await axiosConfig.get(
        `/stores/stores/?page=1&page_size=50&is_suspended=false`
      );
      const stores = response?.data?.results || [];
      const candidates = stores
        .filter((s) => s.latitude && s.longitude && !s.is_suspended)
        .map((s) => ({
          store: s,
          distance: getDistanceInKm(
            parseFloat(lat),
            parseFloat(lng),
            parseFloat(s.latitude),
            parseFloat(s.longitude)
          ),
        }))
        .filter(({ distance }) => distance <= DELIVERY_RADIUS_KM)
        .sort((a, b) => a.distance - b.distance);
      if (preferOnline) {
        const onlineCandidate = candidates.find(
          ({ store }) => store?.is_online === "online"
        );
        return onlineCandidate || null;
      }
      return candidates[0] || null;
    } catch (err) {
      console.log("Fallback store scan failed", err);
      return null;
    }
  };

  // Validates that the chosen delivery address (or current location, when
  // no address has been picked yet) is within the store's serviceable
  // radius.
  const checkServiceability = async () => {
    try {
      const siteData = JSON.parse(localStorage.getItem("site_data") || "{}");
      // Pincode-based mode handles its own validation flow elsewhere.
      if (siteData?.ecommerce_type === "Conventional") {
        // Commenting this out so the banner can show in Conventional mode too
        // setServiceability({ status: "idle", message: "" });
        // return;
      }

      const lat = orderAddress?.latitude || localStorage.getItem("latitude");
      const lng = orderAddress?.longitude || localStorage.getItem("longitude");

      if (!lat || !lng) {
        setServiceability({
          status: "error",
          message: "Please provide a delivery address with location.",
        });
        return;
      }

      setServiceability({ status: "checking", message: "Checking if we deliver to this location..." });
      // const response = await axiosConfig.get(
      //   `/stores/get_store/?latitude=${lat}&longitude=${lng}`
      // );
      const response = { data: { Message: { store_id: 1 } } };
      const msg = response?.data?.Message || {};

      if (!msg.store_id) {
        const fallback = await findServiceableStoreFallback(lat, lng);
        if (fallback) {
          adoptStore(fallback.store);
          setServiceability({
            status: "serviceable",
            message: `Great! We found a store that delivers here (${fallback.distance.toFixed(1)} km away).`,
          });
          return;
        }
        setServiceability({
          status: "not_serviceable",
          message:
            "Sorry, this location is outside our 4 km delivery radius. No nearby store can deliver to this address.",
        });
        return;
      }

      adoptStore({
        id: msg.store_id,
        opens_at: msg.opens_at,
        closes_at: msg.closes_at,
        slot_duration: msg.slot_duration,
        address: msg.address,
      });

      if (msg.is_online === "offline") {
        const onlineFallback = await findServiceableStoreFallback(lat, lng, true);
        if (onlineFallback) {
          adoptStore(onlineFallback.store);
          setServiceability({
            status: "serviceable",
            message: onlineFallback.distance
              ? `Great! We found an open store that delivers here (${onlineFallback.distance.toFixed(1)} km away).`
              : "Great! We found an open store that delivers here.",
          });
          return;
        }
        setServiceability({
          status: "store_offline",
          message: `The nearest store is currently closed${msg.opens_at ? `. Opens at ${msg.opens_at}` : ""}.`,
        });
        return;
      }
      setServiceability({
        status: "serviceable",
        message: "Great! This address is within our delivery range.",
      });
    } catch (err) {
      console.log(err);
      const lat = orderAddress?.latitude || localStorage.getItem("latitude");
      const lng = orderAddress?.longitude || localStorage.getItem("longitude");
      if (lat && lng) {
        const fallback = await findServiceableStoreFallback(lat, lng);
        if (fallback) {
          adoptStore(fallback.store);
          setServiceability({
            status: "serviceable",
            message: `Great! We found a store that delivers here (${fallback.distance.toFixed(1)} km away).`,
          });
          return;
        }
      }
      setServiceability({
        status: "error",
        message: "Could not verify serviceability for this address. Please try again.",
      });
    }
  };

  // Re-check serviceability whenever the chosen address (or modal visibility)
  // changes.
  useEffect(() => {
    if (!show) return;
    if (count !== 1) return;
    checkServiceability();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, count, orderAddress?.id, orderAddress?.latitude, orderAddress?.longitude]);

  const isProceedBlocked =
    serviceability.status === "not_serviceable" ||
    serviceability.status === "store_offline" ||
    serviceability.status === "checking";

  return (
    <div>
      {count === 1 && (
        <Modal
          show={show}
          onHide={handleClose}
          dialogClassName="right-side-modal right-most-side"
          // className={`template-temp2 popup-cart ${miniPopUp ? "zindex-0" : ""}`}
          className={`template-temp2 popup-cart ${miniPopUp ? "zindex-0" : ""} ${showAddressModal ? "hide-cart-modal" : ""}`}
        >
          <Modal.Header closeButton>
            <Modal.Title>My Cart</Modal.Title>
          </Modal.Header>
          <Modal.Body
            className={orderAddress ? "cart-modal-rn" : "cart-modal-address"}
          >
            <div>
              <ViewCart
                handleClose={handleClose}
                ProductData={ProductData}
                Order={Order}
                orderAddress={orderAddress}
                setOrders={setOrders}
                setProductAmount={setProductAmount}
                productAmount={productAmount}
                setTotalAmount={setTotalAmount}
                travelTime={travelTime}
                setMiniPopUp={setMiniPopUp}
                setApiDeliveryCharge={setApiDeliveryCharge}
              />
            </div>
          </Modal.Body>
          {(products?.length > 0 || (cart?.rentCart?.length || 0) > 0) ? (
            <Modal.Footer className="m-2">
              <div className="delivery-location">
                {orderAddress && (
                  <div className="row">
                    {/* <div className="col-2 nav-locat-icon">
                      {(orderAddress.adress_type === "Home" && (
                        <MdOutlineHome />
                      )) ||
                        (orderAddress.adress_type === "Work" && (
                          <MdWorkOutline />
                        )) ||
                        (orderAddress.adress_type === "Others" && (
                          <MdOtherHouses />
                        ))}
                    </div> */}
                    <div className="col-10">
                      <p className="add-type">
                        Delivering to {orderAddress.adress_type}
                      </p>
                      <div className="row">
                        <div className="col-10">
                          <p className="del-address">
                            {orderAddress.name}
                            {orderAddress.flat_no && <span className="text--dark-gray">, {orderAddress.flat_no}</span>}
                            {/* {orderAddress.address_line_1 && <span className="text--dark-gray">, {orderAddress.address_line_1}</span>} */}
                            {/* {orderAddress.address_line_2 && <span className="text--dark-gray">, {orderAddress.address_line_2}</span>} */}
                            {orderAddress.landmark && <span className="text--dark-gray">, {orderAddress.landmark}</span>}
                            {orderAddress.city && <span className="text--dark-gray">, {orderAddress.city}</span>}
                            {orderAddress.state && <span className="text--dark-gray">, {orderAddress.state}</span>}
                            {orderAddress.zipcode && <span className="text--dark-gray"> - {orderAddress.zipcode}</span>}
                            {orderAddress.country && <span className="text--dark-gray">, {orderAddress.country}</span>}
                          </p>
                        </div>
                        <div
                          className="col-2 change-nav"
                          onClick={() => setShowAddressModal(true)}
                        >
                          <p>Change</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* Serviceability validation banner */}
                {serviceability.status !== "idle" && (
                  <div
                    className={`serviceability-banner serviceability-${serviceability.status}`}
                    role={
                      serviceability.status === "not_serviceable" ||
                        serviceability.status === "store_offline" ||
                        serviceability.status === "error"
                        ? "alert"
                        : "status"
                    }
                  >
                    {serviceability.status === "serviceable" ? (
                      <IoMdCheckmarkCircleOutline size={18} className="me-1" />
                    ) : serviceability.status === "checking" ? (
                      <HiOutlineLocationMarker size={18} className="me-1" />
                    ) : (
                      <MdErrorOutline size={18} className="me-1" />
                    )}
                    <span>{serviceability.message}</span>
                  </div>
                )}
              </div>
              <button
                className="btn btn-success btn-proceed"
                disabled={isProceedBlocked}
                onClick={() => {
                  if (isProceedBlocked) return;

                  if (!localStorage.getItem("userId")) {
                    handleLoginShow();
                    return;
                  }

                  if (!orderAddress) {
                    if (!Address || Address.length === 0) {
                      setShowAddressModal(true);
                      return;
                    }

                    GetTheAddress();
                    return;
                  }

                  PayMentNavigate();
                }}
              >
                <p className="p-qty">
                  {(products?.length > 0 || (cart?.rentCart?.length || 0) > 0) ? (
                    <>
                      <div>
                        <span className="p-price">
                          ${proceedTotal.toFixed(2)}
                        </span>
                        <div className="total-text">TOTAL</div>
                      </div>
                      <p className="p-pay">Proceed</p>
                    </>
                  ) : (
                    <p>My Cart</p>
                  )}
                </p>
              </button>
            </Modal.Footer>
          ) : (
            ""
          )}
        </Modal>
      )}
      {count === 2 && (
        <Modal show={show} onHide={handleClose} dialogClassName="right-side-modal right-most-side" className="template-temp2 popup-cart">
          <Modal.Header>
            <Modal.Title>
              <div className="cart-address">
                <div className="left-arrrow" onClick={MovetoCart}>
                  <HiOutlineArrowLeft />
                </div>
                <div className="left-address">
                  {JSON.parse(localStorage.getItem("site_data"))
                    .ecommerce_type !== "Conventional"
                    ? "My Address"
                    : "Enter Delivery Details"}
                </div>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            className={
              isMobile
                ? "cart-modal-rn-address-mobile"
                : "cart-modal-rn-address"
            }
          >
            <div className="add-address-main">
              {JSON.parse(localStorage.getItem("site_data")).ecommerce_type !==
                "Conventional" && (
                  <div className="add-address-nav" onClick={() => setShowAddressModal(true)}>
                    <div className="add-icon-nav">
                      <MdOutlineAddCircleOutline />
                    </div>
                    <div className="address-head-nav">Add a new address in</div>
                  </div>
                )}
              <div>
                {(Address.length > 0 || (DefaultPincode && JSON.parse(localStorage.getItem("site_data"))?.ecommerce_type === "Conventional")) && (
                  <div className="address-p">
                    <div className="d-flex align-items-center justify-content-between">
                      {/* <div>{Address.length > 0 ? "Choose Delivery Address" : ""}</div> */}
                      {JSON.parse(localStorage.getItem("site_data"))
                        .ecommerce_type === "Conventional" && (
                          <div
                            className="address-head-nav"
                            onClick={() => setShowAddressModal(true)}
                            style={{ color: "#735ceb", cursor: "pointer" }}
                          >
                            + Add a new address
                          </div>
                        )}
                    </div>
                  </div>
                )}
                {storeNull && orderAddress?.id && (
                  <div className="Loginerror">
                    Currently, service not available in the selected address
                  </div>
                )}
                {errorMsg && (
                  <div className="Loginerror">
                    Service not available for this selected pincode
                  </div>
                )}
              </div>
              <div className="address-container">
                {Address.length > 0 ? (
                  Address.map((address, i) => (
                    <div
                      key={i}
                      className="address-main d-flex align-items-center"
                    >
                      <div
                        className="form-check"
                        onClick={async () => {
                          const siteData = JSON.parse(
                            localStorage.getItem("site_data")
                          );
                          try {
                            const userId = localStorage.getItem("userId");
                            localStorage.setItem("address_id", address.id);
                            setOrderAddress(address);
                            if (siteData.ecommerce_type !== "Conventional") {
                              GetAddress(address.id);
                            } else {
                              localStorage.setItem("pincode", address?.pincode);
                            }
                            await axiosConfig.post("accounts/default_address/", {
                              user: parseInt(userId),
                              address_id: address.id,
                            });
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <input
                          className="form-check-input"
                          type="radio"
                          name="exampleRadios"
                          checked={orderAddress?.id === address.id}
                          readOnly
                        />
                      </div>
                      <div>
                        <div className="address-ass">
                          {address.address_type || "Delivery Address"}
                        </div>
                        <div className="address-detail">
                          {[
                            address.flat_no,
                            address.address || address.address_line_1,
                            address.address_line_2,
                            address.landmark,
                            address.city,
                            address.state,
                            address.pincode || address.zipcode
                          ].filter(Boolean).join(", ")}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div>
                    <button
                      className="btn btn-primary btn-block"
                      onClick={() => setShowAddressModal(true)}
                    >
                      Add New Address
                    </button>
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-success btn-proceed"
              disabled={!orderAddress || errorMsg}
              onClick={() => setCount(1)}
            >
              <p className="p-pay">Done</p>
            </button>
          </Modal.Footer>
        </Modal>
      )}
      {popupType !== "" && (
        <PopupModal
          popupType={popupType}
          setPopupType={setPopupType}
          error={errorMsg}
          Message={message}
        />
      )}
      <AddressModal
        show={showAddressModal}
        onHide={() => setShowAddressModal(false)}
        onSuccess={async (address) => {
          console.log("Address selected:", address);
          setShowAddressModal(false);
          await getAddresses()
          setOrderAddress(address);
          setCount(1);
        }}
      />
    </div>
  );
};

export default ViewCartModal;
